import { LanguageType } from '@/pages/opinion/types/common';
import { createContext } from 'react';

export type IndicatorsType =
  | 'mentions'
  | 'mentions_ratio'
  | 'sentiment'
  | 'negative_mentions'
  | 'positive_mentions'
  | 'engagement'
  | 'engagement_ratio';

export type TopicTypeType = 'all_topic' | 'key_topic';

export type SentimentType = 'total' | 'positive' | 'negative';
// export type LanguageType = 'origin' | 'en' | 'cn';

export type TopicLevelType = 'L1' | 'L2';

export const FilterContext = createContext<{
  topics: {
    parent: string[];
    children: string[];
    flag: boolean;
  };
  sentimentType: SentimentType;
  filter: any;
  gameInfo: any;
  topicOneLevel: { [key: string]: { [key in LanguageType]: string } };
  topicTwoLevel: { [key: string]: { [key in LanguageType]: string } };
  topicTree: { [key: string]: Array<string> };
  topicLevel: TopicLevelType;
  topicOptions: any;
  transTopic: (
    topic: string,
    topicLevel?: 'L1' | 'L2',
    language?: 'en-US' | 'zh-CN',
  ) => string;
  clickTopicToFeedsFunc: (topic: string, topicLevel: 'L1' | 'L2') => void;
  topicList: any;
}>({
  topics: {
    parent: [],
    children: [],
    flag: true,
  },
  sentimentType: 'total',
  filter: {},
  gameInfo: {},
  topicOneLevel: {},
  topicTwoLevel: {},
  topicTree: {},
  topicOptions: [],
  topicLevel: 'L1',
  transTopic: (topic) => topic,
  clickTopicToFeedsFunc: (topic, topicLevel) => {},
  topicList: {},
});
